import { render } from "./RecuperarClaveView.vue?vue&type=template&id=36079bc2&scoped=true"
import script from "./RecuperarClaveView.vue?vue&type=script&lang=js"
export * from "./RecuperarClaveView.vue?vue&type=script&lang=js"

import "./RecuperarClaveView.vue?vue&type=style&index=0&id=36079bc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36079bc2"]])

export default __exports__